/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/car_1_medium'
export default icon
